import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Calendar: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M27 15a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h18a2 2 0 0 0 2-2V15Zm0-5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1.54A3.98 3.98 0 0 1 7 11h18c.73 0 1.42.2 2 .54V10Zm2 15a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V10a4 4 0 0 1 4-4h1V4a1 1 0 0 1 2 0v2h12V4a1 1 0 0 1 2 0v2h1a4 4 0 0 1 4 4v15Z"
    />
    <path
      fill="currentColor"
      d="m12 22.6 1.92-.84c.16.58.43 1.03.8 1.36a2 2 0 0 0 1.33.49c.6 0 1.08-.18 1.44-.53.37-.34.56-.83.56-1.46 0-.62-.18-1.11-.55-1.46a1.95 1.95 0 0 0-1.4-.52c-.92 0-1.62.38-2.12 1.15l-1.59-.81.93-5.48h5.65v1.92h-4.11l-.41 2.43.02.02c.04-.06.13-.15.28-.28a3.6 3.6 0 0 1 1.86-.52c.96 0 1.76.34 2.4 1.01.66.7.99 1.56.99 2.6 0 1.2-.38 2.13-1.13 2.8a4.06 4.06 0 0 1-2.82 1.02 4.15 4.15 0 0 1-2.55-.77A4.44 4.44 0 0 1 12 22.6Z"
    />
  </Icon>
);
